import React from 'react';

/**
 * BrandName Component
 * 
 * Applies LUMIBRIGHT branding typography pattern to sub-brand names:
 * - "LUMI" part: thin font-weight (300)
 * - Second word: bold font-weight (700)
 * 
 * Examples:
 * - "LUMI INDOOR" → LUMI (thin) INDOOR (bold)
 * - "LUMI OUTDOOR" → LUMI (thin) OUTDOOR (bold)
 * - "LB PRO" → LB (thin) PRO (bold)
 * 
 * Usage:
 *   <BrandName name="LUMI INDOOR" />
 *   <BrandName name="LUMI OUTDOOR" className="text-2xl" />
 */
export default function BrandName({ name, className = '', style = {} }) {
  if (!name) return null;

  // Split the brand name into words
  const words = name.trim().split(/\s+/);
  
  if (words.length < 2) {
    // If it's a single word, just return it normally
    return <span className={className} style={style}>{name}</span>;
  }

  // First word/part (LUMI or LB) gets thin weight
  // Remaining words get bold weight
  const firstPart = words[0];
  const secondPart = words.slice(1).join(' ');

  return (
    <span className={className} style={style}>
      <span style={{ fontWeight: 300, display: 'inline' }}>{firstPart} </span>
      <span style={{ fontWeight: 700, display: 'inline' }}>{secondPart}</span>
    </span>
  );
}
